<template>
  <div>
    <!--国际物流简介  -->
    <div class="baseBreadcrumb">
      <baseBreadcrumb :page="'国际物流简易比较表配置'" :menu="$t('message.operationAndMaintenance')" />
      <el-button type="primary" @click="simpleCompare">保存</el-button>
    </div>
    <div class="body">
      <div class="content" :style="{ width: content.h_title.length + content.c_title.length > 13 ? '2000px' : 'auto' }">
        <div class="row head">
          <!-- 新增 -->
          <div class="add-row">
            <el-button type="success" size="small" @click="addRow">新增一行</el-button>
          </div>
          <!-- 航空 -->
          <div class="logistics">
            <div class="title">
              航 空 便
              <div class="add-item">
                <el-button size="mini" type="success" @click="addItem('h_title', 'h_list')">新增</el-button>
              </div>
            </div>
            <div class="list">
              <div class="item" v-for="(item, index) in content.h_title" :key="index">
                <!-- 全列向左移 -->
                <i class="el-icon-d-arrow-left" @click="upLeft('h_title', 'h_list', index)" v-if="index"></i>
                <el-input v-model="item.name" type="textarea" resize="none"></el-input>
                <i class="el-icon-error" @click="delItem('h_title', 'h_list', index)"></i>
              </div>
            </div>
          </div>
          <!-- 船运 -->
          <div class="logistics" style=" background: linear-gradient(0deg, #5774cc, #678af3);">
            <div class="title">
              船 便
              <div class="add-item">
                <el-button size="mini" type="success" @click="addItem('c_title', 'c_list')">新增</el-button>
              </div>
            </div>
            <div class="list">

              <div class="item" v-for="(item, index) in content.c_title" :key="index">
                <!-- 全列向左移 -->
                <i class="el-icon-d-arrow-left" @click="upLeft('c_title', 'c_list', index)" v-if="index"></i>
                <el-input v-model="item.name" type="textarea" resize="none"></el-input>
                <i class="el-icon-error" @click="delItem('c_title', 'c_list', index)"></i>
              </div>
            </div>
          </div>
          <!-- 删除一行 -->
          <div class="row-error"></div>
        </div>
        <!-- 列表数据 -->
        <vuedraggable class="wrapper" v-model="content.row">
          <div class="row" v-for="(item, index) in content.row" :key="index">
            <div class="add-row"><el-input v-model="item.name" type="textarea" resize="none"></el-input></div>
            <div class="logistics">
              <div class="list">
                <div class="item" v-for="(items, index) in item.h_list" :key="index">
                  <el-input v-model="items.name" type="textarea" resize="none"></el-input>
                </div>
              </div>
            </div>
            <div class="logistics">
              <div class="list">
                <div class="item" v-for="(items, index) in item.c_list" :key="index">
                  <el-input v-model="items.name" type="textarea" resize="none"></el-input>
                </div>
              </div>
            </div>
            <!-- 删除一行 -->
            <div class="row-error">
              <i class="el-icon-error " @click="delRow(index)"></i>
            </div>
          </div>
        </vuedraggable>
      </div>
    </div>
    <h2>国際送料-注意事項</h2>
    <quill-editor id="quill-editor" v-model="content.desc" :options="quillOption">
    </quill-editor>
  </div>
</template>
<script>
import vuedraggable from "vuedraggable";
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    vuedraggable,
    quillEditor,
  },
  data() {
    return {
      quillOption: quillConfig,
      content: {
        desc: '',
        h_title: [
        ],
        c_title: [
        ],
        row: [
        ]
      }
    };
  },
  created() {
    this.$api.siteConfiguration.simpleCompareGet().then(res => {
      if (res.data.value) {
        this.content = JSON.parse(res.data.value)
      }
    })
  },
  methods: {
    // 新增一行
    addRow() {
      let row = { name: '', c_list: [], h_list: [] }
      this.content.h_title.forEach(item => {
        row.h_list.push({ name: '' })
      })
      this.content.c_title.forEach(item => {
        row.c_list.push({ name: '' })
      })
      this.content.row.push(row)
    },
    //删除一行
    delRow(index) {
      this.content.row.splice(index, 1)
      this.$forceUpdate()
    },
    // 新增一列
    addItem(title, list) {
      this.content[title].push({ name: '' })
      this.content.row.forEach(item => {
        item[list].push({ name: '' })
      })
      this.$forceUpdate()
    },
    //删除一列
    delItem(title, list, index) {
      this.content[title].splice(index, 1)
      this.content.row.forEach(item => {
        item[list].splice(index, 1)
      })
      this.$forceUpdate()
    },
    //全列向左移
    upLeft(title, list, index) {
      let titleName = this.content[title][index].name
      this.content[title][index].name = this.content[title][index - 1].name
      this.content[title][index - 1].name = titleName
      this.content.row.forEach(item => {
        let itemName = item[list][index].name
        item[list][index].name = item[list][index - 1].name
        item[list][index - 1].name = itemName
      })
      this.$forceUpdate()
    },
    //简易比较表配置
    simpleCompare() {
      this.$api.siteConfiguration.simpleCompare({ value: JSON.stringify(this.content) }).then((res) => {
        this.$message.success(res.msg)
      });
    },
  }
}
</script>
<style lang='scss' scoped>
.baseBreadcrumb {
  position: relative;

  .el-button {
    position: absolute;
    top: 5px;
    right: 20px;
  }
}

.body {
  overflow-x: auto;
}

.head {
  .logistics {
    background: linear-gradient(0deg, #c64b42, #e76e65);
  }
}

.row {
  display: flex;
  width: 100%;

  .add-row {
    width: 100px;
    background-color: #f6f6f6;
    display: flex;
    justify-content: center;
    align-items: center;

  }

  .logistics {
    padding: 10px;
    min-width: 200px;

    .title {
      font-size: 20px;
      font-weight: bold;
      color: #fff;
      position: relative;

      .add-item {
        position: absolute;
        top: 00px;
        right: 00px;
        cursor: pointer;
      }
    }

    .list {
      display: flex;
      max-width: 1000px;

      .item {
        width: 100px;
        margin: 0 5px;
        position: relative;

        i {
          position: absolute;
          top: -5px;
          right: -5px;
          font-size: 16px;
          cursor: pointer;
        }

        .el-icon-d-arrow-left {
          top: 50%;
          left: -15px;
          color: #fff;
          font-size: 20px;
          transform: translate(0, -50%);
        }
      }
    }
  }
}

/deep/.el-textarea__inner {
  padding: 3px;

}

.row-error {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  font-size: 20px;
  cursor: pointer;
}

h2 {
  text-align: center;
  margin: 30px 0;
  font-size: 40px;
}

/deep/.ql-editor {
  min-height: 200px !important;
  max-height: 600px !important;
}
</style>